import { IPage } from '@types'
//import { eventList } from 'assets/eventsList'
import EventView from 'components/events/EventView'
import Layout from 'components/layouts/Layout'
import { getMenus } from 'lib/getMenus'
import { getServices } from 'lib/getServices'
import { metaDescription } from 'lib/htmlText'
import { setCacheControl } from 'lib/misc'
import { isAbsent, isNotString, isSame } from 'lib/utils'
import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from 'next'

import { IMenuItem, type IServicePortfolio } from 'store/api'

export let getServerSideProps = async ({
  req,
  params,
  res,
}: // eslint-disable-next-line @typescript-eslint/require-await
GetServerSidePropsContext) => {
  // Stop from running on client
  let isFirstServerCall = isSame(
    req?.url?.indexOf('/_next/data/'),
    -1
  )

  const emptyProps = {
    event: {} as IServicePortfolio,
    menus: {} as Record<string, IMenuItem[]>,
    description: '',
  }
  if (!isFirstServerCall)
    return {
      props: emptyProps,
    }

  let slug = params?.['slug'] as string | undefined
  if (isNotString(slug)) return { props: emptyProps, notFound: true }

  let services = await getServices('ru')

  let event = services?.portfolio.find((i) => i.slug === slug!)

  if (isAbsent(event)) return { props: emptyProps, notFound: true }

  // Описание — начало текста мероприятия (отдельного meta-поля у мероприятий нет).
  // У «сервировок» тексты начинаются одним абзацем, и описания совпали бы —
  // совпавшее (или пустое) отличаем названием мероприятия в начале.
  let description = metaDescription(event.text)
  if (
    !description ||
    services.portfolio.some(
      (i) =>
        i.slug !== slug && metaDescription(i.text) === description
    )
  )
    description = metaDescription(
      `${event.name}. ${event.text ?? ''}`
    )

  setCacheControl(res)

  let menus = await getMenus('ru')

  return {
    props: {
      event,
      menus,
      description,
    },
  }
}

export type EventPageProps = Required<
  InferGetServerSidePropsType<typeof getServerSideProps>
>

let EventPage: IPage<EventPageProps> = (props) => (
  <EventView {...props} />
)

EventPage.getLayout = (page: { props: EventPageProps }) => (
  <Layout
    index
    hideBreadcrumbs
    menus={page.props.menus}
    title={page.props?.event?.name}
    description={page.props?.description}
  >
    {page}
  </Layout>
)

export default EventPage
